import isEmpty from 'lodash/isEmpty';
import { MENTAL_HEALTH_QUESTIONNAIRE_KEY } from './constants';

export const getMentalHealthRequirement = (bookingState) => {
    return (
        bookingState?.requirements?.find(
            (rq) => rq.key === MENTAL_HEALTH_QUESTIONNAIRE_KEY
        ) || {}
    );
};

export const getNonMentalHealthRequirements = (bookingState) => {
    return (
        bookingState?.requirements?.filter(
            (rq) => rq.key !== MENTAL_HEALTH_QUESTIONNAIRE_KEY
        ) || []
    );
};

export const mentalHealthRequirementsIsValid = (bookingState) => {
    if (hasMentalHealthRequirement(bookingState)) {
        const requirement = getMentalHealthRequirement(bookingState);
        return !!requirement.value;
    }
    return true;
};

export const hasMentalHealthRequirement = (bookingState) =>
    !isEmpty(getMentalHealthRequirement(bookingState));
